import { render, staticRenderFns } from "./OpenClose.vue?vue&type=template&id=2d5cd7c1&scoped=true&"
import script from "./OpenClose.vue?vue&type=script&lang=ts&"
export * from "./OpenClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cd7c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5cd7c1')) {
      api.createRecord('2d5cd7c1', component.options)
    } else {
      api.reload('2d5cd7c1', component.options)
    }
    module.hot.accept("./OpenClose.vue?vue&type=template&id=2d5cd7c1&scoped=true&", function () {
      api.rerender('2d5cd7c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/OpenClose.vue"
export default component.exports